import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useChatroom } from '../contexts/ChatroomContext';
import { ChannelList } from '../components/ChannelList/ChannelList';
import { MessagePane } from '../components/MessagePane/MessagePane';
import { MessageInput } from '../components/MessageInput/MessageInput';
import { ChannelSettingsModal } from '../components/ChannelSettingsModal';
import './ChatPage.css';

export function ChatPage() {
  const { user, logout } = useAuth();
  const { channels, activeChannelId, activeChannel, selectChannel, findChannelBySlug } = useChatroom();
  const [showSettings, setShowSettings] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const { spaceSlug, channelSlug } = useParams();

  // Sync URL params with channel selection
  useEffect(() => {
    if (spaceSlug && channelSlug && channels.length > 0) {
      const channel = findChannelBySlug(spaceSlug, channelSlug);
      if (channel && channel.id !== activeChannelId) {
        selectChannel(channel.id);
      }
    }
  }, [spaceSlug, channelSlug, channels, activeChannelId, findChannelBySlug, selectChannel]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  // Close sidebar when a channel is selected (mobile UX)
  const handleChannelSelect = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="chat-page">
      <div className="chat-header">
        <div className="chat-header-left">
          <button
            className="mobile-menu-button"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle channel list"
          >
            ☰
          </button>
          <Link to="/chatrooms" className="chat-header-link"><h1>Chatrooms</h1></Link>
        </div>
        <div className="user-info">
          <span className="username">{user?.username || 'User'}</span>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </div>
      <div className={`chat-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
        <ChannelList onChannelSelect={handleChannelSelect} />
        <div className="chat-main">
          <div className="chat-main-header">
            {activeChannel && (
              <>
                <span className="active-channel-name">#{activeChannel.name}</span>
                <button
                  className="settings-button"
                  onClick={() => setShowSettings(true)}
                  title="Channel settings"
                >
                  ⚙️
                </button>
              </>
            )}
          </div>
          <MessagePane />
          <MessageInput />
        </div>
      </div>

      {showSettings && activeChannel && (
        <ChannelSettingsModal
          channel={activeChannel}
          onClose={() => setShowSettings(false)}
        />
      )}
    </div>
  );
}
